import { writable } from 'svelte/store'

export const toolsMapInteraction = writable([
    {
        layerLast:'',
        layerPrevious:'',
        latitud:19.45065,
        longitud:-97.12194,
        centerMap:{
          latitud:'',
          longitud:''
        },
        goLatitud:'',
        goLongitud:'',
        centerStatus:false,
        identifyHtml:'',
        attributionMap:false,
        toolsMeasure:false,
        typeMeasure:'',
        distanceMeasure:0,
        areaMeasure:0,
        polygonMeasure:'',
        layerMeasure:'',
        countPolygon:0,
        entitySelected:'',
        entidadBase:'',
        municipioBase:'',
        municipioNom:'',
        statusEstados:false,
        statusMunicipios:false,
        statusPloty:true,
        statusTable:false,
        statusPanels:true,
        downloadPolygon:'#',
        fileDownload:'csv',
        downloadGeojson:{},
        nivelAdminFilter:1,
        pointsBbox:[],
        projection:'wgs84'
      }
])